module.exports = __webpack_public_path__ + "static/media/category-icon.88f8defa.svg";